import { Api } from './axios-config';

export interface IServicePackageView {
  id: number;
  businessId: number;
  name: string;
  description?: string;
  amount: number;
  totalUses: number;
  validityDays?: number;
  active: boolean;
  serviceId: number;
  serviceName: string;
  commissionPercent?: number;
}

export interface ICreateServicePackage {
  businessId: number;
  name: string;
  description?: string;
  amount: number;
  totalUses: number;
  validityDays?: number;
  serviceId: number;
  commissionPercent?: number;
}

export interface IUpdateServicePackage {
  id: number;
  name: string;
  description?: string;
  amount: number;
  totalUses: number;
  validityDays?: number;
  active: boolean;
  serviceId: number;
  commissionPercent?: number;
}

const getById = async (id: number): Promise<IServicePackageView> => {
  try {
    const { data } = await Api.get<IServicePackageView>(`/servicePackage/${id}`);
    return data;
  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : String(error));
  }
};

const getByBusiness = async (businessId: number): Promise<IServicePackageView[]> => {
  try {
    const { data } = await Api.get<IServicePackageView[]>(`/servicePackage/business/${businessId}`);
    return data;
  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : String(error));
  }
};

const create = async (body: ICreateServicePackage): Promise<number> => {
  try {
    const { data } = await Api.post('/servicePackage', body);
    return data;
  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : String(error));
  }
};

const update = async (body: IUpdateServicePackage): Promise<IServicePackageView> => {
  try {
    const { data } = await Api.put('/servicePackage', body);
    return data;
  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : String(error));
  }
};

const remove = async (id: number): Promise<void> => {
  try {
    await Api.delete(`/servicePackage/${id}`);
  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : String(error));
  }
};

export const servicePackageService = {
  getById,
  getByBusiness,
  create,
  update,
  remove,
};
